import React from 'react'
import {Field, reduxForm} from 'redux-form'

const required = value => (value || typeof value === 'number' ? undefined : 'Required')

const renderField = ({
                         input,
                         label,
                         type,
                         meta: {touched, error, warning},
                         helpString
                     }) => (
    <div>
        <label>{label}</label>
        <div className="help">{helpString}</div>
        <div>
            <input {...input} placeholder={label} type={type}/>
            {touched &&
            ((error && <span>{error}</span>) ||
                (warning && <span>{warning}</span>))}
        </div>
    </div>
);

const number = value =>
    value && isNaN(Number(value)) ? 'Must be a number' : undefined;

let ContactForm = props => {
    const {handleSubmit} = props;
    return (
        <form onSubmit={handleSubmit}>
            <div className="field-container">

                <Field
                    name="capitalCosts"
                    type="number"
                    label="Capital costs"
                    component={renderField}
                    validate={[required, number]}
                />
                <div className="help">Capital costs are fixed, one-time expenses incurred on the purchase of land,
                    buildings, construction, and equipment. The sum of the different type of costs related to the
                    considered investment, for example the capital costs of building refurbishment, new EE and RES
                    installations, infrastructure reconstruction etc.
                </div>
            </div>
            <div className="field-container">
                <Field
                    name="annualSavings"
                    type="number"
                    label="Annual Energy Savings"
                    component={renderField}
                    validate={[required, number]}

                />
                <div className="help">Annual sum of money savings generated by the investment, for instance costs saved
                    for heating, hot water preparation, electricity etc.
                </div>
            </div>
            <div className="field-container">
                <Field
                    name="annualRevenues"
                    type="number"
                    label="Annual Revenues"
                    component={renderField}
                    validate={[required, number]}
                />
                <div className="help">Annual sum of money generated by the investment, for instance electricity sales
                    received on a basis of feed in tarrifs, overall heat and electricity sales to customers etc.
                </div>
            </div>
            <div className="field-container">
                <Field
                    name="operationalCosts"
                    type="number"
                    label="Operational Costs"
                    component={renderField}
                    validate={[required, number]}
                />
                <div className="help">Annual operational costs including salaries, maintenance etc., these costs need to
                    be calculated individually per each operational cost category depending on demandigness of the
                    maintenance and operation of the investment.
                </div>
            </div>
            <div className="field-container">
                <Field
                    name="otherCosts"
                    type="number"
                    label="Other costs per year"
                    component={renderField}
                    validate={[required]}
                />
                <div className="help">Other annual costs including depreciation, taxes, fees, energy costs etc., i.e.
                    other costs depending on a specific situation in each country
                </div>
            </div>
            <div className="field-container">
                <Field
                    name="discountRate"
                    type="number"
                    label="Discount rate"
                    component={renderField}
                    validate={[required]}
                />
                <div className="help">
                    <p>
                        Rate used to discount future cash flows in order to obtain their present value. The rate
                        generally viewed as being the most appropriate is an organisation´s weighed cost of capital*
                        i.e. the minimum average rate of return it must earn on its current assets to satisfy its
                        shareholders or owners, its investors, and its creditors. In other words, it is the interest
                        percentage that a company or investor anticipates receiving over the life of an investment. For
                        instance, if municipality considers the investment into any project the discount rate should be
                        higher, at least, as the long-term interest rate of time deposit in a bank.
                    </p>
                    <p>
                        Municipalities normally use discount rates ranging from 3% to 18%, for public sector it is
                        tenable to set this rate close to the lower limit."
                    </p>
                    <p>*A company's weighted average cost of capital is the average interest
                        rate it must pay to finance its assets, growth and working capital. It is also the minimum
                        average rate of return it must earn on its current assets to satisfy its shareholders or owners,
                        its investors, and its creditors.</p>
                </div>
            </div>

        </form>
    )
};

ContactForm = reduxForm({
    // a unique name for the form
    form: 'calculator'
})(ContactForm);

export default ContactForm
